<template>
	<div :class="$style['cart-inner']">
		<ProductsTable
			:delete-func="handleRemoveFromCart"
			:update-func="handleUpdateCartQuantity"
			:products="cartProducts"
		/>
	</div>
</template>

<script>
import ProductsTable from './ProductsTable'
import {
	mapActions,
	mapGetters
} from '@/store/modules/App/Cart/helpers'
import {
	FETCH_CART_PRODUCTS,
	REMOVE_FROM_CART,
	UPDATE_QUANTITY
} from '@/store/modules/App/Cart/action-types'

export default {
	name: 'CartInner',
	components: {
		ProductsTable
		// PartsTable
	},
	computed: {
		...mapGetters({
			cartProducts: 'cartProducts',
			cart: 'cart'
		})
	},
	mounted () {
		this.handleFetchProducts()
	},
	methods: {
		...mapActions({
			fetchProducts: FETCH_CART_PRODUCTS,
			removeFromCart: REMOVE_FROM_CART,
			updateQuantity: UPDATE_QUANTITY
		}),

		async handleFetchProducts () {
			try {
				const payload = {
					cartIds: [this.cart.id],
					productQueryType: 'cart'
					// departmentIds: this.$auth().selectedDepartmentId ? [this.$auth().selectedDepartmentId] : null
				}
				await this.fetchProducts(payload)
			} catch (e) {
				return Promise.reject(e)
			}
		},

		async handleRemoveFromCart (product) {
			try {
				await this.removeFromCart(product)
				this.$emit('refetch')
			} catch (e) {
				return Promise.reject(e)
			}
		},

		async handleUpdateCartQuantity (updatedProduct) {
			try {
				await this.updateQuantity(updatedProduct)
				this.$emit('refetch')
			} catch (e) {
				return Promise.reject(e)
			}
		}

	}
}
</script>

<style lang="scss" module>

	.cart-inner {
		background-color: getColor(surface);
		height: 100%;
		display: flex;
		align-items: center;
		margin: $gutter * 2 0;
	}
</style>
